import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Form, Formik, FormikValues } from "formik";
import React, { SyntheticEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  EC_SUBMISSION_TYPES,
  RoutingList,
  stepsInfo,
} from "../../../../constants";
import { useCreateEcsMutation } from "../../../../generated/graphql";
import { formikMultiStepHandler } from "../../../../utils/formikMultiStepFormStepHandler";
import { a11yProps } from "../../../../utils/helper";
import { logger } from "../../../../utils/logger";
import CreatePageFormFooter from "../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import ProgressSteps from "../../../common/ProgressSteps/ProgressSteps";
import TabPanel from "../../../common/TabPanel/TabPanel";
import ECSubmissionPVPD from "../ECSubmission/ECSubmissionPVPD";
import StudyDetailsPvpd from "../StudyDetails/StudyDetailsPvpd";
import {
  PvpdInitData,
  PvpdStudyDetailsValidation,
  SAE_SUB_SECTIONS,
} from "../utils";
import InitialReport from "./InitialReport/InitialReport";

type IRProps = {};

const SaeTab = (props: IRProps) => {
  const [SAESubmissionTabValue, setSAESubmissionTabValue] = useState(0);
  const handleECSubmissionTabChange = (
    event: SyntheticEvent,
    newValue: any
  ) => {
    setSAESubmissionTabValue(newValue);
  };

  return (
    <Card>
      <CardContent className="pd-x-30 pd-y-30">
        <Box className="mg-b-40">
          <Typography className="mg-b-10" variant="h2" component="h2">
            SAE Reporting/MSMC
          </Typography>
          <Container maxWidth={false}>
            <div>
              <Box className={`custom-tabs`}>
                <Tabs
                  value={SAESubmissionTabValue}
                  onChange={handleECSubmissionTabChange}
                  aria-label="tabs"
                >
                  <Tab
                    label={SAE_SUB_SECTIONS.INITIAL_REPORT}
                    {...a11yProps(0)}
                  />
                  <Tab label={SAE_SUB_SECTIONS.FOLLOW_UP_1} {...a11yProps(1)} />
                  <Tab label={SAE_SUB_SECTIONS.FOLLOW_UP_2} {...a11yProps(2)} />
                  <Tab
                    label={SAE_SUB_SECTIONS.FINAL_AND_ANALYSED_REPORT}
                    {...a11yProps(3)}
                  />
                </Tabs>
                <TabPanel value={SAESubmissionTabValue} index={0}>
                  <InitialReport value={SAE_SUB_SECTIONS.INITIAL_REPORT} />
                </TabPanel>
                <TabPanel value={SAESubmissionTabValue} index={1}>
                  <InitialReport value={SAE_SUB_SECTIONS.FOLLOW_UP_1} />
                </TabPanel>
                <TabPanel value={SAESubmissionTabValue} index={2}>
                  <InitialReport value={SAE_SUB_SECTIONS.FOLLOW_UP_2} />
                </TabPanel>
                <TabPanel value={SAESubmissionTabValue} index={3}>
                  <InitialReport
                    value={SAE_SUB_SECTIONS.FINAL_AND_ANALYSED_REPORT}
                  />
                </TabPanel>
              </Box>
            </div>
          </Container>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SaeTab;
